export default {
      id: "flag-au-usage",
      viewBox: "0 10 36 20",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#flag-au",
      toString: function () {
        return this.url;
      }
    }